require.register("description/util/parserEnvironment", function(exports, require, module){
  $0
  
});

